/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ResetPasswordRepresentation {
  loginType?: ResetPasswordRepresentation.LoginTypeEnum;
  loginValue?: string;
  code?: string;
  password?: string;
}
export namespace ResetPasswordRepresentation {
  export type LoginTypeEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const LoginTypeEnum = {
    USERNAME: 'USERNAME' as LoginTypeEnum,
    FIRST_NAME: 'FIRST_NAME' as LoginTypeEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as LoginTypeEnum,
    LAST_NAME: 'LAST_NAME' as LoginTypeEnum,
    NAME: 'NAME' as LoginTypeEnum,
    AVATAR: 'AVATAR' as LoginTypeEnum,
    GENDER: 'GENDER' as LoginTypeEnum,
    BIRTHDAY: 'BIRTHDAY' as LoginTypeEnum,
    FOUNDED: 'FOUNDED' as LoginTypeEnum,
    DISSOLVED: 'DISSOLVED' as LoginTypeEnum,
    DAY: 'DAY' as LoginTypeEnum,
    MONTH: 'MONTH' as LoginTypeEnum,
    YEAR: 'YEAR' as LoginTypeEnum,
    EMAIL: 'EMAIL' as LoginTypeEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as LoginTypeEnum,
    PHONE: 'PHONE' as LoginTypeEnum,
    FAX: 'FAX' as LoginTypeEnum,
    WEBSITE: 'WEBSITE' as LoginTypeEnum,
    BIC: 'BIC' as LoginTypeEnum,
    JOB_TITLE: 'JOB_TITLE' as LoginTypeEnum,
    INDUSTRY: 'INDUSTRY' as LoginTypeEnum,
    GROUP: 'GROUP' as LoginTypeEnum,
    REGION: 'REGION' as LoginTypeEnum,
    ADDRESS: 'ADDRESS' as LoginTypeEnum,
    STREET: 'STREET' as LoginTypeEnum,
    COUNTRY: 'COUNTRY' as LoginTypeEnum,
    BUILDING: 'BUILDING' as LoginTypeEnum,
    BOX: 'BOX' as LoginTypeEnum,
    LOCALITY: 'LOCALITY' as LoginTypeEnum,
    NUMBER: 'NUMBER' as LoginTypeEnum,
    ZIP: 'ZIP' as LoginTypeEnum,
    DISTRICT: 'DISTRICT' as LoginTypeEnum,
    PROVINCE: 'PROVINCE' as LoginTypeEnum,
    SUBURB: 'SUBURB' as LoginTypeEnum,
    STATE: 'STATE' as LoginTypeEnum,
    COUNTY: 'COUNTY' as LoginTypeEnum,
    LAT_LONG: 'LAT_LONG' as LoginTypeEnum,
    FACEBOOK: 'FACEBOOK' as LoginTypeEnum,
    YOUTUBE: 'YOUTUBE' as LoginTypeEnum,
    INSTAGRAM: 'INSTAGRAM' as LoginTypeEnum,
    WHATSAPP: 'WHATSAPP' as LoginTypeEnum,
    WECHAT: 'WECHAT' as LoginTypeEnum,
    TIKTOK: 'TIKTOK' as LoginTypeEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as LoginTypeEnum,
    TELEGRAM: 'TELEGRAM' as LoginTypeEnum,
    SNAPCHAT: 'SNAPCHAT' as LoginTypeEnum,
    PINTEREST: 'PINTEREST' as LoginTypeEnum,
    TWITTER: 'TWITTER' as LoginTypeEnum,
    REDDIT: 'REDDIT' as LoginTypeEnum,
    LINKEDIN: 'LINKEDIN' as LoginTypeEnum,
    VIMEO: 'VIMEO' as LoginTypeEnum,
    DISCORD: 'DISCORD' as LoginTypeEnum,
    TWITCH: 'TWITCH' as LoginTypeEnum,
    TUMBLR: 'TUMBLR' as LoginTypeEnum,
    MASTODON: 'MASTODON' as LoginTypeEnum,
    PATREON: 'PATREON' as LoginTypeEnum,
    KICKSTARTER: 'KICKSTARTER' as LoginTypeEnum,
    INDIEGOGO: 'INDIEGOGO' as LoginTypeEnum,
    GOFUNDME: 'GOFUNDME' as LoginTypeEnum,
    TAKEAWAY: 'TAKEAWAY' as LoginTypeEnum,
    UBEREATS: 'UBEREATS' as LoginTypeEnum,
    DELIVEROO: 'DELIVEROO' as LoginTypeEnum,
    SHIPTO: 'SHIPTO' as LoginTypeEnum,
    WEIBO: 'WEIBO' as LoginTypeEnum,
    QQ: 'QQ' as LoginTypeEnum,
    KUAISHOU: 'KUAISHOU' as LoginTypeEnum,
    QZONE: 'QZONE' as LoginTypeEnum,
    SKYPE: 'SKYPE' as LoginTypeEnum,
    NOTE: 'NOTE' as LoginTypeEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as LoginTypeEnum,
    LEGAL_NAME: 'LEGAL_NAME' as LoginTypeEnum,
    LEGAL_FORM: 'LEGAL_FORM' as LoginTypeEnum,
    LEGAL_ID: 'LEGAL_ID' as LoginTypeEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as LoginTypeEnum,
    JURISDICTION: 'JURISDICTION' as LoginTypeEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as LoginTypeEnum,
    PROPOSAL: 'PROPOSAL' as LoginTypeEnum,
    CATEGORY: 'CATEGORY' as LoginTypeEnum,
    OPENING_HOURS: 'OPENING_HOURS' as LoginTypeEnum,
    CUSTOM: 'CUSTOM' as LoginTypeEnum,
    FILE: 'FILE' as LoginTypeEnum,
    IMAGE: 'IMAGE' as LoginTypeEnum,
    FILE_KEY: 'FILE_KEY' as LoginTypeEnum,
    FILE_NAME: 'FILE_NAME' as LoginTypeEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as LoginTypeEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as LoginTypeEnum,
    DOCUMENT: 'DOCUMENT' as LoginTypeEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as LoginTypeEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as LoginTypeEnum,
  };
}
